// extracted by mini-css-extract-plugin
export default {"container":"order-details_container__0x6Xv","title":"order-details_title__Rj-FU","image":"order-details_image__PRE53"};